import { Field, Label, Select, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useGetTiltakskategorier } from '../../../../../../components/tiltakSection/tiltakForm/useGetTiltakskategorier';
import { EnergiObjektType } from '../../../../../../utils/matrikkelBygningsTyper';
import { useTiltakFormContext } from '../utils';

export const UnderkategoriSelect = ({ energiobjekttype }: { energiobjekttype: EnergiObjektType }) => {
  const { register, watch, formState } = useTiltakFormContext();
  const { t } = useTranslation();

  const { tiltakskategorier } = useGetTiltakskategorier(energiobjekttype as EnergiObjektType);
  const selectedKategori = watch('kategori');
  const selectedTiltaksKategori = tiltakskategorier?.find(({ kategori }) => kategori === selectedKategori);
  const tiltakTyper = selectedTiltaksKategori?.tiltaksliste || [];
  const error = formState.errors.underkategori?.message;

  return (
    <Field>
      <Label htmlFor="underkategori">{t('screens.energiplan.components.tiltakForm.underkategoriSelect.label')}</Label>
      <Select
        id="underkategori"
        aria-invalid={!!error}
        defaultValue=""
        width="full"
        disabled={!selectedKategori}
        {...register('underkategori', {
          required: t('screens.energiplan.components.tiltakForm.underkategoriSelect.required')
        })}
      >
        <Select.Option disabled value="">
          {t('screens.energiplan.components.tiltakForm.underkategoriSelect.placeholder')}
        </Select.Option>
        {tiltakTyper.map((tiltakType) => (
          <Select.Option key={tiltakType} value={tiltakType}>
            {t(`tiltak.${tiltakType}`)}
          </Select.Option>
        ))}
      </Select>
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Field>
  );
};
